module.exports = __webpack_public_path__ + "media/images/service/ser_bg-6e6e7808b1bb4b382714a098f7bcb98c.png";